import React from "react";

export const useForceRender = () => {
  const [counter, setCounter] = React.useState(0);
  return React.useCallback(() => setCounter(x => x + 1), []);
};
